'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
		var calcToolkit = require('@lifetime-gallagher/calculator-toolkit');
		var incomeTax = calcToolkit.incomeTax;
		var nationalInsurance = calcToolkit.nationalInsurance;
		var dateConstants = calcToolkit.dateConstants;
		var ModelOutput = require('../lib/modelOutput');
	}
}

var Cost = function(employerMatchTable, taxYear) {
	this.employerMatchTable = employerMatchTable;
	this.taxYear = taxYear;
	this.timePeriod = Cost.MONTHLY;
};

Cost.MONTHLY = dateConstants.MONTHS_IN_YEAR;
Cost.ANNUALLY = 1;

//set the time period on which a cost should be provided
// any arbitary number can be used, but using the constants defined is preferable
Cost.prototype.setTimePeriod = function(timePeriod) {
	this.timePeriod = timePeriod;
};

Cost.prototype.payForRelief = function(contributionRate, salary) {
	return salary - (salary * contributionRate);
};

//employee contribution (£)
Cost.prototype.employeeContribution = function(contributionRate, salary) {
	var employeeContribution = new ModelOutput();
	employeeContribution.setValue((contributionRate * salary) / this.timePeriod);
	return employeeContribution;
};

//employer contribution (£)
Cost.prototype.employerContribution = function(contributionRate, salary, increment) {
	var employerContribution = new ModelOutput();
	employerContribution.setValue((this.employerMatchTable.p.getErContributionRate(contributionRate, increment) * salary) / this.timePeriod);
	return employerContribution;
};

//tax relief (£)
Cost.prototype.taxRelief = function(contributionRate, salary) {
	var taxRelief = new ModelOutput();
	var payForTaxRellief = this.payForRelief(contributionRate, salary);
	taxRelief.setValue((incomeTax.annualPayable(salary, this.taxYear).total - incomeTax.annualPayable(payForTaxRellief, this.taxYear).total) / this.timePeriod);
	return taxRelief;
};

//NI saving (if salary sacrificing) (£)
Cost.prototype.nationalInsuranceSaving = function(contributionRate, salary, salarySacrificeContributions) {
	var nationalInsuranceSaving = new ModelOutput();
	var payForNationalInsurnanceSaving = this.payForRelief(contributionRate, salary);
	if(!salarySacrificeContributions) {
		nationalInsuranceSaving.setValue(0);
	}
	else {
		nationalInsuranceSaving.setValue((nationalInsurance.annualPayable(salary, this.taxYear).total - nationalInsurance.annualPayable(payForNationalInsurnanceSaving, this.taxYear).total) / this.timePeriod);
	}

	return nationalInsuranceSaving;
};

Cost.prototype.netCost = function(contributionRate, salary, salarySacrificeContributions) {
	var netCost = new ModelOutput();
	netCost.setValue(this.employeeContribution(contributionRate, salary).getValue() - this.taxRelief(contributionRate, salary).getValue() - this.nationalInsuranceSaving(contributionRate, salary, salarySacrificeContributions).getValue());
	return netCost;
};

Cost.prototype.totalInvested = function(contributionRate, salary) {
	var totalInvested = new ModelOutput();
	totalInvested.setValue(this.employeeContribution(contributionRate, salary).getValue() + this.employerContribution(contributionRate, salary).getValue());
	return totalInvested;
};

//export for node
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = Cost;
    }
    exports.Cost = Cost;
}